import React, { createContext, useContext, useState, useEffect } from "react";
import api from '../utils/api';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);

  const validateToken = async () => {
    try {
      const response = await api.get("/auth/verify");
      return response.data.isValid && response.data.isAdmin;
    } catch (error) {
      console.error("Token validation error:", error);
      return false;
    }
  };

  useEffect(() => {
    const initializeAuth = async () => {
      if (token) {
        // Устанавливаем токен в заголовки запросов
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        const isValid = await validateToken();
        if (isValid) {
          setIsAuthenticated(true);
          setIsAdmin(true);
        } else {
          logout();
        }
      }
      setIsLoading(false);
    };

    initializeAuth();
  }, [token]);

  const register = async (email, password) => {
    try {
      await api.post("/auth/register", {
        email,
        password,
      });
      return true;
    } catch (error) {
      console.error("Registration error:", error);
      throw error.response?.data?.message || "Ошибка при регистрации";
    }
  };

  const login = async (email, password) => {
    try {
      const response = await api.post("/auth/login", {
        email,
        password,
      });
      
      const { token: newToken } = response.data;
      
      // Устанавливаем токен в заголовки запросов
      api.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      
      // Проверяем права администратора
      const isValid = await validateToken();
      if (!isValid) {
        throw new Error("Нет прав администратора");
      }

      localStorage.setItem("token", newToken);
      setToken(newToken);
      setIsAuthenticated(true);
      setIsAdmin(true);
      return true;
    } catch (error) {
      console.error("Login error:", error);
      throw error.response?.data?.message || error.message || "Ошибка при входе";
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    delete api.defaults.headers.common['Authorization'];
    setToken(null);
    setIsAuthenticated(false);
    setIsAdmin(false);
  };

  const value = {
    isAuthenticated,
    isAdmin,
    token,
    login,
    logout,
    isLoading,
    register
  };

  if (isLoading) {
    return null;
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
